import { NAVIGATION_RAIL_WIDTH } from '@/utils/constants';

import type { TDocumentViewerSpace } from './types';

const HISTORY_SIDEBAR_SELECTOR = '.ApplicationLayoutSidebar:not(.right)';

/**
 * Reads the space the Viewer and the conversation currently share (the chat window, less the navigation rail,
 * less the thread history while it is open).
 *
 * Kept apart from the layout rules so both the layout hook and the opening width can take their own
 * measurement, and so the rules themselves stay a pure function of the numbers.
 * @returns The window width and the width the thread history takes beside the rail.
 */
export const measureDocumentViewerSpace = (): TDocumentViewerSpace => {
  const historySidebar = document.querySelector(HISTORY_SIDEBAR_SELECTOR);
  const historySidebarWidth = historySidebar?.getBoundingClientRect().width ?? NAVIGATION_RAIL_WIDTH;

  return {
    windowWidth: window.innerWidth,
    historyWidth: Math.max(0, historySidebarWidth - NAVIGATION_RAIL_WIDTH),
  };
};
